const EntityType = [
  { value: 1, name: 'Bank', description: 'Bank' },
  { value: 2, name: 'Branch', description: 'Branch' },
  { value: 3, name: 'BrokerDealer', description: 'Broker-Dealer' },
  { value: 4, name: 'Fund', description: 'Fund' },
  { value: 5, name: 'InsuranceCompany', description: 'Insurance Company' },
  { value: 6, name: 'InvestmentAdvisor', description: 'Investment Advisor' },
  { value: 7, name: 'ManagedFund', description: 'Managed Fund' },
  { value: 8, name: 'NonBankFinancialInstitution', description: 'Non-Bank Financial Institution' },
  { value: 9, name: 'Spv', description: 'SPV' },
  { value: 10, name: 'InvestorFund', description: 'Investor Fund' },
  { value: 11, name: 'FundFamily', description: 'Fund Family' },
  { value: 12, name: 'CentralBank', description: 'Central Bank' },
  { value: 13, name: 'GovernmentEntity', description: 'Government Entity' },
  { value: 14, name: 'InternationalOrganization', description: 'International Organization' },
  { value: 15, name: 'OtherEntity', description: 'Other Entity' },
  { value: 16, name: 'OtherInvestmentEntity', description: 'Other Investment Entity' },
  { value: 17, name: 'PubliclyTradedEntity', description: 'Publicly Traded Entity' },
  { value: 100, name: 'Individual', description: 'Individual' },
  { value: 200, name: 'Other', description: 'Other' },

];

EntityType.getSortedTypes = () => EntityType.sort((a, b) => {
  if (a.description > b.description) return 1;
  return (b.description > a.description) ? -1 : 0;
});

export default EntityType;
